import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { RecaptchaService } from 'app/services/recaptcha.service';
import { validateForm } from 'app/shared/form-elements/form-validateForm.function';
import { DonorRegistrationVm } from 'app/shared/generated/Models/Public/DonorRegistrationVm';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pcg-donor-registration',
    templateUrl: './donor-registration.component.html',
    styleUrls: ['./donor-registration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DonorRegistrationComponent {

	honeypotControl;

	id: number;
	formGroup = DonorRegistrationVm.Form;
	subscriptions = new Subscription();
	model = new DonorRegistrationVm();
	currentDate: any = new Date();
	canManualEntry = true;
	isSuccess = false;
	disableSave = false;

	phoneValidation = { pattern: "Invalid phone number" };

    isSubmitting = signal<boolean>(false);

	constructor(
        public router: Router
        , private httpClient: HttpClient
        , title: Title
        , private ms: SystemMessageService
        , private recaptchaService : RecaptchaService
    ) {
		title.setTitle('Donor Registration');
	}

	ngOnInit() {
		if (isNaN(this.id) || this.id == 0) {
			this.setUpHoneyPot();
			this.formGroup.get('dateSigned').patchValue(this.currentDate.toLocaleString());
		}
	}

	setUpHoneyPot() {
		this.formGroup.controls['honeyPot'].setValidators(this.requireFalse());
		this.formGroup.updateValueAndValidity();
	}

	requireFalse(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (control.value === true) { return { honeyPot: true }; }
			return null;
		}
	}

    saveDonor() {
		if (!this.formGroup.valid) {
            validateForm(this.formGroup);
            return;
		}

        // Submit with reCAPTCHA protection
        this.recaptchaService.submit(
            {
                action: 'saveRxConnectsDonor',
                apiEndpoint: 'api/PublicDonorRegistration/SaveDonor/',
                formGroup: this.formGroup,
                loadingSignal: this.isSubmitting
            },
            {
                onSuccess: (msg: SystemMessage) => {
                    if (msg.isSuccessful) {
                        this.isSuccess = true;
                        this.disableForm();
                    } else {
                        this.isSuccess = false;
                        this.ms.setSystemMessage(msg.message, "error");
                    }
                }
            }
        );
	}

	disableForm() {
		this.formGroup.disable();
		this.disableSave = true;
	}

	updateCounty() {
		const address = this.formGroup.value.smartyAddress;

		if (address === null || address.countyName === null) { return; }
		this.httpClient.get(`api/PublicDonorRegistration/GetCountyByName?countyName=${address.countyName}`).subscribe((countyId: number) => {
			if (countyId !== 0) {
				this.formGroup.get('countyId').patchValue(countyId)
				document.getElementById('contactName').focus();
			}
			else {
				this.formGroup.get('countyId').patchValue(0)
				document.getElementById('countyId').focus();
			}
		});
	}
}
